const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  reLogin: state => state.user.reLogin,
  logined: state => state.user.logined,
  showHeader: state => state.showHeader,
  showUserHeader: state => state.showUserHeader,
  activeTab: state => state.activeTab,
  showAddInteres: state => state.showAddInteres,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js